// import 'objectFitPolyfill';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';
import './features/scroll-indicators';
import './features/in-view';
import './features/dashed-bar';
import './features/user-manager';

import './views/menu';
import './views/left-menu';
import './views/user-menu';
import './views/cart';

import './view-initalizer';
